import { createStyles, makeStyles } from '@material-ui/styles';
import * as React from 'react';
import { FC, useState } from 'react';
import { tertiaryColor } from 'src/constants/stylesheet';
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  EmailShareButton,
  EmailIcon
} from 'react-share';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      position: 'relative',
    },
    sharerToggler: {
      position: 'relative',
      width: 30,
      height: 30,
      backgroundColor: 'transparent',
      border: 'none',
      borderRadius: '100%',
      padding: 0,
      cursor: 'pointer',
    },
    sharerDot: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 3,
      height: 3,
      backgroundColor: tertiaryColor,

      '&:before': {
        content: '""',
        position: 'absolute',
        top: -6,
        left: 0,
        // translform: 'translate(-50%, -50%)',
        width: 3,
        height: 3,
        borderRadius: '100%',
        backgroundColor: tertiaryColor,
      },

      '&:after': {
        content: '""',
        position: 'absolute',
        top: 6,
        left: 0,
        // translform: 'translate(-50%, -50%)',
        width: 3,
        height: 3,
        borderRadius: '100%',
        backgroundColor: tertiaryColor,
      }
    },
    sharerContent: {
      position: 'absolute',
      top: 30,
      right: 0,
      padding: '10px 5px',
      boxShadow: '0 3px 8px 0 rgba(0,0,0,.2)',
      backgroundColor: 'white',

      display: 'flex',

      '& > div': {
        margin: '0 5px',
        cursor: 'pointer',
      }
    }
  }));
export type SharerProps = {
  url: string;
};

type Props = SharerProps;

const Sharer: FC<Props> = ({ url }) => {
  const cls = useStyles();
  const [showSharer, setShowSharer] = useState(false);

  // useEffect(() => {
  //   const handleWindowClick = () => {
  //     if (showSharer) { 
  //       setShowSharer(false);
  //     }
  //   }

  //   window.addEventListener('click', handleWindowClick);

  //   return () => {
  //     window.removeEventListener('click', handleWindowClick);
  //   }
  // }, [showSharer]);

  const handleSharerToggle = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    e.preventDefault();

    setShowSharer(!showSharer);
  };

  return (
    <div className={cls.root}>
      <button
        className={cls.sharerToggler}
        // tslint:disable-next-line:jsx-no-lambda
        onClick={(e) => handleSharerToggle(e)}
      >
        <span className={cls.sharerDot} />
      </button>
      {showSharer &&
        <div className={cls.sharerContent}>
          <FacebookShareButton url={url}>
            <FacebookIcon size={30} round={true} />
          </FacebookShareButton>
          <TwitterShareButton url={url}>
            <TwitterIcon size={30} round={true} />
          </TwitterShareButton>
          <EmailShareButton url={url}>
            <EmailIcon size={30} round={true} />
          </EmailShareButton>
        </div>
      }
    </div>
  );
};

export default Sharer;


// WEBPACK FOOTER //
// ./src/Components/Sharer.tsx